import {
  FETCHING_STORYBOARD_REPORT_SUMMARY, FETCHING_STORYBOARD_REPORT_SUMMARY_SUCCEEDED, FETCHING_STORYBOARD_REPORT_SUMMARY_FAILED,
  FETCHING_STORYBOARD_VISITORS_REPORTS, FETCHING_STORYBOARD_VISITORS_REPORTS_SUCCEEDED, FETCHING_STORYBOARD_VISITORS_REPORTS_FAILED,
  FETCHING_STORYBOARD_INTERACTIONS_REPORTS, FETCHING_STORYBOARD_INTERACTIONS_REPORTS_SUCCEEDED, FETCHING_STORYBOARD_INTERACTIONS_REPORTS_FAILED,
  FETCHING_STORYBOARD_SESSIONS_TIME_SERIES, FETCHING_STORYBOARD_SESSIONS_TIME_SERIES_SUCCEEDED, FETCHING_STORYBOARD_SESSIONS_TIME_SERIES_FAILED,
  FETCHING_STORYBOARD_UNIQUE_VISITORS_TRENDS, FETCHING_STORYBOARD_UNIQUE_VISITORS_TRENDS_SUCCEEDED, FETCHING_STORYBOARD_UNIQUE_VISITORS_TRENDS_FAILED,
  FETCHING_STORYBOARD_METRICS_REPORTS, FETCHING_STORYBOARD_METRICS_REPORTS_SUCCEEDED, FETCHING_STORYBOARD_METRICS_REPORTS_FAILED,
  FETCHING_STORYBOARD_CHARTS_METRICS_REPORTS, FETCHING_STORYBOARD_CHARTS_METRICS_REPORTS_SUCCEEDED, FETCHING_STORYBOARD_CHARTS_METRICS_REPORTS_FAILED,
  FETCH_REPORTS_DATA_FOR_DOWNLOAD, FETCH_REPORTS_DATA_FOR_DOWNLOAD_SUCCEEDED, FETCH_REPORTS_DATA_FOR_DOWNLOAD_FAILED, INVALIDATE_DOWNLOAD_DATA,
  FETCHING_STORYBOARD_LEADS_TIME_SERIES, FETCHING_STORYBOARD_LEADS_TIME_SERIES_SUCCEEDED, FETCHING_STORYBOARD_LEADS_TIME_SERIES_FAILED,
  FETCHING_STORYBOARD_ASSETS_ANALYTICS, FETCHING_STORYBOARD_ASSETS_ANALYTICS_SUCCEEDED, FETCHING_STORYBOARD_ASSETS_ANALYTICS_FAILED,
  FETCHING_ASSETS_ANALYTICS_FOR_DOWNLOAD, FETCHING_ASSETS_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED, FETCHING_ASSETS_ANALYTICS_FOR_DOWNLOAD_FAILED, INVALIDATE_ASSET_DOWNLOAD_DATA,
  FETCH_ANALYTICS_CHART_FOR_ASSET, FETCHING_ANALYTICS_CHART_FOR_ASSET_SUCCEEDED, FETCHING_ANALYTICS_CHART_FOR_ASSET_FAILED, 
  FETCH_DOCUMENT_PREVIEW, FETCHING_DOCUMENT_PREVIEW_SUCCEEDED, FETCHING_DOCUMENT_PREVIEW_FAILED,
  FETCHING_JOURNEY_REPORTS, FETCHING_JOURNEY_REPORTS_FAILED, FETCHING_JOURNEY_REPORTS_SUCCEEDED
} from 'constants/actionTypes';

import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';
import _ from 'lodash';
import FileService from 'services/file.service';

const paperfliteApiUrl = process.env.REACT_APP_PAPERFLITE_API_URL;
const ASSETS_BASE_URL = `${paperfliteApiUrl}/api/2.0/assets`;

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const STORYBOARD_REPORTS_BASE_URL = `${apiUrl}/api/1.0/storyboard/reports`;

/**
 * Fetch Storyboard summary
*/
export const fetchStoryboardReportSummary = createAction(FETCHING_STORYBOARD_REPORT_SUMMARY, (request) => {
  return {
    request: request
  }
});

const fetchStoryboardReportSummarySucceeded = createAction(FETCHING_STORYBOARD_REPORT_SUMMARY_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchStoryboardReportSummaryFailed = createAction(FETCHING_STORYBOARD_REPORT_SUMMARY_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchStoryboardReportSummarySaga(action) {
  const { request } = action.payload;

  let url = buildUrl(STORYBOARD_REPORTS_BASE_URL, {
    path: `/summary`
  });

  const fetchStoryboardReportSummaryAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchStoryboardReportSummaryAPI);
    if (response) {
      yield put(fetchStoryboardReportSummarySucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchStoryboardReportSummaryFailed(request.storyboard, error));
  }
}

/**
 * Fetch Storyboard visitors
*/
export const fetchStoryboardVisitorsReport = createAction(FETCHING_STORYBOARD_VISITORS_REPORTS, (request, page, limit) => {
  return {
    request: request,
    page: page,
    limit: limit
  }
});

const fetchStoryboardVisitorsReportSucceeded = createAction(FETCHING_STORYBOARD_VISITORS_REPORTS_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchStoryboardVisitorsReportFailed = createAction(FETCHING_STORYBOARD_VISITORS_REPORTS_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchStoryboardVisitorsReportSaga(action) {
  const { request, page, limit } = action.payload;

  let url = buildUrl(STORYBOARD_REPORTS_BASE_URL, {
    path: `/sessions?page=${page}&limit=${limit}`
  });

  const fetchStoryboardVisitorsReportAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchStoryboardVisitorsReportAPI);
      if (response) {
        yield put(fetchStoryboardVisitorsReportSucceeded(request.storyboard, response));
      }
  } catch (error) {
      yield put(fetchStoryboardVisitorsReportFailed(request.storyboard, error));
  }
}

/**
 * Fetch Storyboard page views time series
*/
export const fetchStoryboardInteractionsReport = createAction(FETCHING_STORYBOARD_INTERACTIONS_REPORTS, (request, page, limit) => {
  return {
    request: request,
    page: page,
    limit: limit
  }
});

const fetchingInterationsReportForLandingPageSucceeded = createAction(FETCHING_STORYBOARD_INTERACTIONS_REPORTS_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchingInteractionsReportForLandingPageFailed = createAction(FETCHING_STORYBOARD_INTERACTIONS_REPORTS_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
});

function* fetchingStoryboardInteractionsReportSaga(action) {
  const { request, page, limit } = action.payload;

  let url = buildUrl(STORYBOARD_REPORTS_BASE_URL, {
    path: `/interactions?page=${page}&limit=${limit}`
  });

  const fetchingStoryboardInteractionsReportAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchingStoryboardInteractionsReportAPI);
    if (response) {
      yield put(fetchingInterationsReportForLandingPageSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchingInteractionsReportForLandingPageFailed(request.storyboard, error));
  }
}

/**
 * Fetch Storyboard session time series
*/
export const fetchStoryboardSessionsTimeSeries = createAction(FETCHING_STORYBOARD_SESSIONS_TIME_SERIES, (request) => {
  return {
    request: request
  }
});

const fetchStoryboardSessionsTimeSeriesSucceeded = createAction(FETCHING_STORYBOARD_SESSIONS_TIME_SERIES_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchStoryboardSessionsTimeSeriesFailed = createAction(FETCHING_STORYBOARD_SESSIONS_TIME_SERIES_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
});

function* fetchingStoryboardSessionsTimeSeriesSaga(action) {
  const { request } = action.payload;

  let url = buildUrl(STORYBOARD_REPORTS_BASE_URL, {
    path: `/sessions/graph`
  });

  const fetchingStoryboardSessionsTimeSeriesAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchingStoryboardSessionsTimeSeriesAPI);
    if (response) {
      yield put(fetchStoryboardSessionsTimeSeriesSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchStoryboardSessionsTimeSeriesFailed(request.storyboard, error));
  }
}


/**
 * Fetch Storyboard Lead time series
*/
export const fetchStoryboardLeadsTimeSeries = createAction(FETCHING_STORYBOARD_LEADS_TIME_SERIES, (request) => {
  return {
    request: request
  }
});

const fetchStoryboardLeadsTimeSeriesSucceeded = createAction(FETCHING_STORYBOARD_LEADS_TIME_SERIES_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchStoryboardLeadsTimeSeriesFailed = createAction(FETCHING_STORYBOARD_LEADS_TIME_SERIES_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
});

function* fetchingStoryboardLeadsTimeSeriesSaga(action) {
  const { request } = action.payload;

  let url = buildUrl(STORYBOARD_REPORTS_BASE_URL, {
    path: `/leads/graph`
  });

  const fetchingStoryboardSessionsTimeSeriesAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchingStoryboardSessionsTimeSeriesAPI);
    if (response) {
      yield put(fetchStoryboardLeadsTimeSeriesSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchStoryboardLeadsTimeSeriesFailed(request.storyboard, error));
  }
}


/**
 * Fetch Storyboard unique visitors trends
*/
export const fetchStoryboardUniqueVisitorsTrends = createAction(FETCHING_STORYBOARD_UNIQUE_VISITORS_TRENDS, (request) => {
  return {
    request: request
  }
});

const fetchingStoryboardUniqueVisitorsTrendsSucceeded = createAction(FETCHING_STORYBOARD_UNIQUE_VISITORS_TRENDS_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchingStoryboardUniqueVisitorsTrendsFailed = createAction(FETCHING_STORYBOARD_UNIQUE_VISITORS_TRENDS_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
});

function* fetchingStoryboardUniqueVisitorsTrendsSaga(action) {
  const { request } = action.payload;

  let url = buildUrl(STORYBOARD_REPORTS_BASE_URL, {
    path: `/sessions/graph`
  });

  const fetchingStoryboardUniqueVisitorsTrendsAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchingStoryboardUniqueVisitorsTrendsAPI);
    if (response) {
      yield put(fetchingStoryboardUniqueVisitorsTrendsSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchingStoryboardUniqueVisitorsTrendsFailed(request.storyboard, error));
  }
}

/**
 * 
 * Fetch page metrics for report 
 */

export const fetchPageMetricsForType = createAction(FETCHING_STORYBOARD_METRICS_REPORTS, (request, page, limit) => {
  return {
    request: request,
    page: page,
    limit: limit
  }
});

const fetchingPageMetricsForTypeSucceeded = createAction(FETCHING_STORYBOARD_METRICS_REPORTS_SUCCEEDED, (id, response, type) => {
  return {
    id: id,
    response: response,
    type: type
  }
});

const fetchingPageMetricsForTypeFailed = createAction(FETCHING_STORYBOARD_METRICS_REPORTS_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
});

function* fetchingPageMetricsForTypeSaga(action) {

  const { request, page, limit } = action.payload;

  let url = buildUrl(STORYBOARD_REPORTS_BASE_URL, {
    path: `/metrics/${request.metricType}?page=${page}&limit=${limit}`
  });

  const fetchingPageMetricsForTypeAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchingPageMetricsForTypeAPI);
    if (response) {
      yield put(fetchingPageMetricsForTypeSucceeded(request.storyboard, response, request.metricType));
    }
  } catch (error) {
    yield put(fetchingPageMetricsForTypeFailed(request.storyboard, error));
  }
}

/**
 * 
 * Fetch page metrics for charts
 */

export const fetchChartMetricsForType = createAction(FETCHING_STORYBOARD_CHARTS_METRICS_REPORTS, (request, page, limit) => {
  return {
    request: request,
    page: page,
    limit: limit
  }
});

const fetchingChartMetricsForTypeSucceeded = createAction(FETCHING_STORYBOARD_CHARTS_METRICS_REPORTS_SUCCEEDED, (id, response, type) => {
  return {
    id: id,
    response: response,
    type: type
  }
});

const fetchingChartMetricsForTypeFailed = createAction(FETCHING_STORYBOARD_CHARTS_METRICS_REPORTS_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
});

function* fetchingChartMetricsForTypeSaga(action) {

  const { request, page, limit } = action.payload;

  let url = buildUrl(STORYBOARD_REPORTS_BASE_URL, {
    path: `/metrics/${request.metricType}?page=${page}&limit=${limit}`
  });

  const fetchingPageMetricsForTypeAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchingPageMetricsForTypeAPI);
    if (response) {
      yield put(fetchingChartMetricsForTypeSucceeded(request.storyboard, response, request.metricType));
    }
  } catch (error) {
    yield put(fetchingChartMetricsForTypeFailed(request.storyboard, error));
  }
}

/**
 * Fetch Reports Data For Download
*/
export const fetchReportsDataForDownload = createAction(FETCH_REPORTS_DATA_FOR_DOWNLOAD, (request, page, limit) => {
  return {
    request: request,
    page: page,
    limit: limit
  }
});

const fetchReportsDataForDownloadSucceeded = createAction(FETCH_REPORTS_DATA_FOR_DOWNLOAD_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchReportsDataForDownloadFailed = createAction(FETCH_REPORTS_DATA_FOR_DOWNLOAD_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* downloadReportsSaga(action) {
  const { request, page, limit } = action.payload;

  try {
    let url = buildUrl(STORYBOARD_REPORTS_BASE_URL, {
      path: `/sessions?page=${page}&limit=${limit}`
    });

    const fetchReportsDataForDownloadAPI = () => {
      return axios.post(url, request).then(response => response.data);
    }

    var response = yield call(fetchReportsDataForDownloadAPI);

    if (response) {
      const { records, ...pagination } = response;
      const hasMoreItems = _.get(pagination, 'currentPage') < _.get(pagination, 'totalPages') - 1;

      var nextPage = page + 1;

      if (hasMoreItems) {
        yield put(fetchReportsDataForDownload(request, nextPage, limit));
      }

      yield put(fetchReportsDataForDownloadSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchReportsDataForDownloadFailed(request.storyboard, error));
  }
}

/**
 Fetch assets analytics For Download
 */
export const fetchAssetAnalyticsForDownload = createAction(FETCHING_ASSETS_ANALYTICS_FOR_DOWNLOAD, (request, page, limit) => {
  return {
    request: request,
    page: page,
    limit: limit
  }
});

const fetchAssetAnalyticsForDownloadSucceeded = createAction(FETCHING_ASSETS_ANALYTICS_FOR_DOWNLOAD_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchAssetAnalyticsForDownloadFailed = createAction(FETCHING_ASSETS_ANALYTICS_FOR_DOWNLOAD_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
});

function* downloadAssetReportSaga(action) {
  const { request, page, limit } = action.payload;

  try {
    let url = buildUrl(STORYBOARD_REPORTS_BASE_URL, {
      path: `/assets?page=${page}&limit=${limit}`
    });

    const fetchingStoryboardAssetAnalyticsAPI = () => {
      return axios.post(url, request).then(response => response.data);
    }

    var response = yield call(fetchingStoryboardAssetAnalyticsAPI);
    console.log('reponse from saga is ', response);

    if (response) {
      const { records, ...pagination } = response;
      const hasMoreItems = _.get(pagination, 'currentPage') < _.get(pagination, 'totalPages') - 1;
      var nextPage = page + 1;

      if (hasMoreItems) {
        yield put(fetchAssetAnalyticsForDownload(request, nextPage, limit));
      }

      yield put(fetchAssetAnalyticsForDownloadSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchAssetAnalyticsForDownloadFailed(request.storyboard, error));
  }
}

/**
 * Fetch Storyboard assets analytics
*/
export const fetchStoryboardAssetAnalytics = createAction(FETCHING_STORYBOARD_ASSETS_ANALYTICS, (request, page, limit) => {
  return {
    request: request,
    page: page,
    limit: limit
  }
});

const fetchingStoryboardAssetAnalyticsSucceeded = createAction(FETCHING_STORYBOARD_ASSETS_ANALYTICS_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchingStoryboardAssetAnalyticsFailed = createAction(FETCHING_STORYBOARD_ASSETS_ANALYTICS_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
});

function* fetchingStoryboardAssetAnalyticsSaga(action) {
  const { request, page, limit } = action.payload;

  let url = buildUrl(STORYBOARD_REPORTS_BASE_URL, {
    path: `/assets?page=${page}&limit=${limit}`
  });

  const fetchingStoryboardAssetAnalyticsAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchingStoryboardAssetAnalyticsAPI);
    if (response) {
      yield put(fetchingStoryboardAssetAnalyticsSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchingStoryboardAssetAnalyticsFailed(request.storyboard, error));
  }
}

/**
 * Fetch Trends Analytics Chart for assets analytics
*/
export const fetchAnalyticsChartForAssetAnalytics = createAction(FETCH_ANALYTICS_CHART_FOR_ASSET, (request, asset) => {
  return {
    request: request,
    asset: asset
  }
});

const fetchAnalyticsChartForAssetAnalyticsSucceeded = createAction(FETCHING_ANALYTICS_CHART_FOR_ASSET_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchAnalyticsChartForAssetAnalyticsFailed = createAction(FETCHING_ANALYTICS_CHART_FOR_ASSET_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
});

function* fetchAnalyticsChartForAssetAnalyticsSaga(action) {
  const { request, asset } = action.payload;

  const metaData = _.get(asset, 'metadata', null);
  let contentType = FileService.fileContentType(metaData);

  let url = buildUrl(STORYBOARD_REPORTS_BASE_URL, {
    path: `/asset/analytics`
  });

  const fetchAnalyticsChartForAssetAnalyticsAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchAnalyticsChartForAssetAnalyticsAPI);
    if (response) {
      yield put(fetchAnalyticsChartForAssetAnalyticsSucceeded(request.assetMappingId, response));

      if(contentType == 'DOCUMENT'){
        yield put(fetchDocumentPreview(asset, request.assetMappingId));
      }
    }
  } catch (error) {
    yield put(fetchAnalyticsChartForAssetAnalyticsFailed(request.assetMappingId, error));
  }
}

/**
 * Fetch Preview For Document
*/
export const fetchDocumentPreview = createAction(FETCH_DOCUMENT_PREVIEW, (asset, assetMappingId) => {
  return {
    asset: asset,
    assetMappingId: assetMappingId
  }
});

const fetchingDocumentPreviewSucceeded = createAction(FETCHING_DOCUMENT_PREVIEW_SUCCEEDED, (assetMappingId, asset, response) => {
  return {
    assetMappingId: assetMappingId,
    asset: asset,
    response: response
  }
});

const fetchingDocumentPreviewFailed = createAction(FETCHING_DOCUMENT_PREVIEW_FAILED, (assetMappingId, error) => {
  return {
    assetMappingId: assetMappingId,
    error: error
  }
});

function* fetchDocumentPreviewSaga(action) {
  const { asset, assetMappingId } = action.payload;

  let url = buildUrl(ASSETS_BASE_URL, {
    path: `/${asset.id}/preview`
  });

  const fetchDocumentPreviewAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchDocumentPreviewAPI);
    if (response) {
      yield put(fetchingDocumentPreviewSucceeded(assetMappingId, asset, response));
    }
  } catch (error) {
      yield put(fetchingDocumentPreviewFailed(assetMappingId, error));
  }
}

/**
 * Fetch Journey Reports
*/
export const fetchingJourneyReports = createAction(FETCHING_JOURNEY_REPORTS, (request, page, limit) => {
  return {
    request: request,
    page: page,
    limit: limit
  }
});

const fetchingJourneyReportsSucceeded = createAction(FETCHING_JOURNEY_REPORTS_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchingJourneyReportsFailed = createAction(FETCHING_JOURNEY_REPORTS_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchingJourneyReportsSaga(action) {
  const { request, page, limit } = action.payload;

  let url = buildUrl(STORYBOARD_REPORTS_BASE_URL, {
    path: `/journey?page=${page}&limit=${limit}`
  });

  const fetchingfetchingJourneyReportsAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchingfetchingJourneyReportsAPI);
      if (response) {
        yield put(fetchingJourneyReportsSucceeded(request.storyboard, response));
      }
  } catch (error) {
      yield put(fetchingJourneyReportsFailed(request.storyboard, error));
  }
}

/**
 * Invalidate Download Data
*/
export const invalidateDownloadData = createAction(INVALIDATE_DOWNLOAD_DATA);

export  const invalidateAssetDownloadData = createAction(INVALIDATE_ASSET_DOWNLOAD_DATA);

export default function* storyboardReportsSaga() {
  yield takeEvery(FETCHING_STORYBOARD_REPORT_SUMMARY, fetchStoryboardReportSummarySaga);
  yield takeEvery(FETCHING_STORYBOARD_VISITORS_REPORTS, fetchStoryboardVisitorsReportSaga);
  yield takeEvery(FETCHING_STORYBOARD_INTERACTIONS_REPORTS, fetchingStoryboardInteractionsReportSaga);
  yield takeEvery(FETCHING_STORYBOARD_SESSIONS_TIME_SERIES, fetchingStoryboardSessionsTimeSeriesSaga);
  yield takeEvery(FETCHING_STORYBOARD_LEADS_TIME_SERIES, fetchingStoryboardLeadsTimeSeriesSaga);
  yield takeEvery(FETCHING_STORYBOARD_UNIQUE_VISITORS_TRENDS, fetchingStoryboardUniqueVisitorsTrendsSaga);
  yield takeEvery(FETCHING_STORYBOARD_METRICS_REPORTS, fetchingPageMetricsForTypeSaga);
  yield takeEvery(FETCHING_STORYBOARD_CHARTS_METRICS_REPORTS, fetchingChartMetricsForTypeSaga);
  yield takeEvery(FETCHING_STORYBOARD_ASSETS_ANALYTICS, fetchingStoryboardAssetAnalyticsSaga);
  yield takeEvery(FETCHING_ASSETS_ANALYTICS_FOR_DOWNLOAD, downloadAssetReportSaga);
  yield takeEvery(FETCH_REPORTS_DATA_FOR_DOWNLOAD, downloadReportsSaga);
  yield takeEvery(FETCH_ANALYTICS_CHART_FOR_ASSET, fetchAnalyticsChartForAssetAnalyticsSaga);
  yield takeEvery(FETCH_DOCUMENT_PREVIEW, fetchDocumentPreviewSaga);
  yield takeEvery(FETCHING_JOURNEY_REPORTS, fetchingJourneyReportsSaga);
}